<template>
  <o-view>
    <o-view>
      <o-nav-bar title="Velo jaarkaart" :has-back-button="true" />
      <o-header-image image="images/velo-header.jpg" />
      <o-section>
        <p>Je hebt een actief Velo-abonnement</p>
      </o-section>
      <o-section>
        <o-key-value label="Product" value="Velo jaarkaart" />
        <o-key-value label="Geldig vanaf" value="13/02/2020" />
        <o-key-value label="Geldig tot" value="13/02/2021" />
      </o-section>
      <o-section>
        <o-checkbox name="renew">Abonnement automatisch vernieuwen</o-checkbox>
      </o-section>
    </o-view>
    <o-pay-button label="Bevestigen" to="/sales/bike" />
  </o-view>
</template>

<script>
import OSalesView from '@/components/OSalesView.vue'
import OHeaderImage from '@/components/OHeaderImage.vue'
import OTitle from '@/components/base/OTitle.vue'
import OKeyValue from '@/components/base/OKeyValue.vue'
import OCheckbox from '@/components/base/OCheckbox.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'VeloAboManage',
  components: {
    OPayButton,
    OCheckbox,
    OKeyValue,
    OTitle,
    OHeaderImage,
    OSalesView
  }
}
</script>
